// extracted by mini-css-extract-plugin
module.exports = {"container":"TeaserBasic_container__VvoEU","header":"TeaserBasic_header__56_Lv","content":"TeaserBasic_content__1Kfc3"};